import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Thermostat, ThermostatAuto, Tune } from '@mui/icons-material';
import { List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
const benefits = [
    {
        title: 'Мониторинг температуры в помещении',
        icon: _jsx(Thermostat, { color: "info", fontSize: "large" }),
    },
    {
        title: 'Поддержка заданной температуры',
        icon: _jsx(ThermostatAuto, { color: "warning", fontSize: "large" }),
    },
    {
        title: 'Удалённое управление',
        icon: _jsx(Tune, { color: "primary", fontSize: "large" }),
    },
];
export function SocketThermostatBenefits() {
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "subtitle1", color: "textSecondary", children: "\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0435 \u043F\u0440\u0438\u0431\u043E\u0440\u043E\u043C \u0441 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u043D\u044B\u043C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u043E\u043C" }), _jsx(List, { children: benefits.map(({ title, icon }, i) => (_jsxs(ListItem, { children: [_jsx(ListItemIcon, { children: icon }), _jsx(ListItemText, { primary: title })] }, i))) })] }));
}
